import Button from './button';
import debounce from '../helpers/debounce';
class BIForm {
    constructor(data) {
        this.form = $(data.form_id);
        this.read_url = data.read_url;
        this.populateFields.bind(this);
        let submitButtonText = null;
        if (data.submitButtonText) {
            submitButtonText = data.submitButtonText;
        }
        this.submitButton = new Button($('button[type="submit"]', this.form), submitButtonText);

        $('input', this.form).on("keyup change", debounce((e) => {
            this.clearError(e.target);
        }, 10));

        $('select', this.form).on("change", (e) => {
            this.clearError(e.target)
        });

        this.onFailCallback = function () { };
    }

    onFail(func) {
        this.onFailCallback = func;
    }

    populateFields(id, callback) {
        var self = this;

        let url = self.read_url;
        if (id) {
            url = `${url}/${id}`;
        }

        axios
            .get(url)
            .then(function (response) {
                Object.keys(response.data.data).forEach(function (key) {

                    var value = response.data.data[key];
                    // populate inputs
                    $(`input[name="${key}"]`, self.form).val(value);

                    // populate selects
                    $(`select[name="${key}"]`, self.form).val(value);

                    // populate textarea
                    $(`textarea[name="${key}"]`, self.form).html(value);

                    let $selectCustom = $(`select[name="${key}"].select_custom`, self.form);
                    if ($selectCustom.length > 0) {
                        $selectCustom.updateVal(value);
                    }

                    // populate checkboxes
                    $(`input:checkbox[name = "${key}"]`, self.form).prop(
                        "checked",
                        value
                    );

                });

                callback(self.form, response.data.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    }

    showErrors(errorJson) {

        if (errorJson == null) {
            return false;
        }

        if (errorJson.message) {
            $('#generalError #errorMessage').text(errorJson.message);
            $('#generalError').modal('show');
            $("#generalError").on('hidden.bs.modal', function (e) {
                $('#generalError #errorMessage').text('');
            });
        } else {
            if (typeof errorJson === 'object') {
                for (var err in errorJson) {
                    if (Symbol.iterator in Object(errorJson[err])) {
                        for (var errstr of errorJson[err]) {
                            if (
                                !$("[name='" + err + "']", this.form).hasClass("is-invalid")
                            ) {
                                if ($("[name='" + err + "']:radio").length > 0) {
                                    $("[name='" + err + "']:radio")
                                        .first()
                                        .parents('.input-group')
                                        .addClass("is-invalid")
                                        .after(
                                            "<div class='invalid-feedback'>" + errstr + "</div>"
                                        );
                                } else {
                                    if ($("[name='" + err + "']", this.form).hasClass("select_custom")) {
                                        $("[name='" + err + "']", this.form)
                                            .first()
                                            .parents('.select')
                                            .addClass("is-invalid")
                                            .after(
                                                "<div class='invalid-feedback'>" + errstr + "</div>"
                                            );
                                    } else {
                                        $("[name='" + err + "']", this.form)
                                            .addClass("is-invalid")
                                            .after(
                                                "<div class='invalid-feedback'>" + errstr + "</div>"
                                            );
                                    }
                                }
                            }
                            else {
                                $("[name='" + err + "']", this.form)
                                    .addClass("is-invalid")
                                    .after(
                                        "<div class='invalid-feedback'>" + errstr + "</div>"
                                    );

                            }
                        }
                    }
                    $("[name='" + Object.keys(errorJson)[0] + "']", this.form).trigger('focus');
                }
            }
        }

        this.onFailCallback();
    }

    clearError(element) {
        $(element)
            .removeClass("is-invalid")
            .next('.invalid-feedback').remove();
    }

    addSubmitListener(callback, callback_before = () => true) {
        var self = this;
        var callback_submit = callback;
        const callback_before_submit = callback_before;

        // remove any previous submit handlers attached to this form
        // this is needed to prevent duplicate form submission
        this.form.off("submit");

        this.form.on("submit", function () {
            if (!callback_before_submit()) {
                return false;
            }
            var action = $(this).attr("action");
            var method = $(this).attr("method");

            if (action.includes("/update")) {
                method = 'patch';
            }

            $("input", this).removeClass("is-invalid");
            $("select", this).removeClass("is-invalid");
            $(".invalid-feedback", this).remove();

            self.turnFormLoadingOn();

            axios({
                method: method,
                url: action,
                data: $(this).serialize()
            })
                .then(function (response) {
                    callback_submit(response.data);
                })
                .catch(function (error) {

                    if (error.hasOwnProperty("response")) {

                        if (error['response'].hasOwnProperty("data")) {
                            self.showErrors(error.response.data);
                        }
                    }

                    self.turnFormLoadingOff();

                });
            return false;
        });

        return this;
    }

    turnFormLoadingOn() {
        $(this.form).animate({ opacity: 0.6 }, 200).css("cursor", "progress");
        if (this.submitButton) {
            this.submitButton.turnLoadingOn();
        }
    }

    turnFormLoadingOff() {
        $(this.form).animate({ opacity: 1 }, 200).css("cursor", "default");
        if (this.submitButton) {
            this.submitButton.turnLoadingOff();
        }
    }

    setAction(action) {
        $(this.form).attr('action', action);
    }

    setMethod(method) {
        $(this.form).attr('method', method);
    }

    emptyForm(onlyVisible = false) {
        let inputsSelector = ':input';

        if (onlyVisible) {
            inputsSelector = inputsSelector + ':visible';
        }

        $(inputsSelector, this.form)
            .not(':button, :submit, :reset')
            .not('[name="_token"]')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
    }

    hideDropdown(name) {
        $(`select[name="${name}"]`, this.form).hideSelect();
    }

    displayError(message) {
        if (message == null) {
            return false;
        }

        if (message) {
            $('#generalError #errorMessage').text(message);
            $('#generalError').modal('show');
            $("#generalError").on('hidden.bs.modal', function (e) {
                $('#generalError #errorMessage').text('');
            });
        }
    }

    showSuccess(message) {
        if (message == null) {
            return false;
        }

        if (message) {

            $(this).find('.alert').remove();
            
            $(this.form).prepend(`
                <div class="alert alert-success text-center" role="alert">
                    ${message}
                </div>
            `);
        }
    }
}

export default BIForm;
